import { Box, Typography } from "@mui/material";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";
import { EServiceGroup } from "@constants";
import { useDeviceType } from "@hooks/useDeviceType";
import marketingInformationImage from "@static/img/broadband/marketingInformation.png";
import marketingInformationBroadbandImage from "@static/img/broadband/marketingInformationBroadband.png";
import { useStyle } from "./style";
import { CardTag } from "@common/CardTag/CardTag";
import { useTheme } from "@mui/material/styles";

interface IActionButton {
    label: string;
    onClick?(): void;
}

interface IParams {
    title: string;
    description: string;
    variant: EServiceGroup;
    badgeLabel?: string;
    actionButton?: IActionButton;
}

export const HomeMarketingInformationBanner = (props: IParams) => {
    const { title, description, variant, badgeLabel, actionButton } = props;
    const { classes } = useStyle();
    const theme = useTheme();
    const { isMobile } = useDeviceType();

    const isMobileMarketingInformation = variant === EServiceGroup.MOBILE || isMobile;
    const imageInformation = isMobileMarketingInformation
        ? { src: marketingInformationImage, alt: "Mobile marketing information" }
        : { src: marketingInformationBroadbandImage, alt: "Broadband marketing information" };

    return (
        <div className={classes.container}>
            <div className={classes.card}>
                <div className={classes.content}>
                    {badgeLabel && (
                        <Box width="fit-content">
                            <CardTag
                                backgroundColor={theme.palette.quaternary.main}
                                color="secondary"
                                isCompactLayout
                                label={badgeLabel.toUpperCase()}
                            />
                        </Box>
                    )}
                    <Typography color="secondary" variant="h2">
                        {title}
                    </Typography>
                    <Typography color="secondary" variant="normal">
                        {description}
                    </Typography>
                    {actionButton && (
                        <div className={classes.actionContainer}>
                            <LabeledButton
                                color="primary"
                                labelText={actionButton.label}
                                onClick={actionButton.onClick}
                            >
                                {actionButton.label}
                            </LabeledButton>
                        </div>
                    )}
                </div>
                <img alt={imageInformation.alt} className={classes.image} src={imageInformation.src} />
            </div>
        </div>
    );
};
